<div class="container pb-4 pb-lg-5">
    <div class="row">
        <p class="instuction-title mb-0 pb-3 pb-lg-4">instructions</p>
        <div class="col-12 px-0 px-md-2">
            <div class="tab-content">
                <div class="tab-pane fade show active" id="fp_tab7">
                    <div class="table-responsive">
                        <table class="table table-hover align-middle text-wrap document-table">
                            <thead class="table-data">
                                <tr>
                                    <th class="doc-sku-col">SKU</th>
                                    <!-- <th class="doc-name-col d-none d-sm-table-cell"></th> -->
                                    <th class="doc-icon-col d-none d-sm-table-cell"></th>
                                    <th class="doc-action-col d-none d-sm-table-cell"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="doc-row" *ngFor="let instruction of instructionsData">
                                    <td class="doc-sku">{{instruction.sku}}</td>
                                    <!-- <td class="doc-name">{{instruction.file_name}}</td> -->
                                    <td class="doc-action">
                                        <span class="doc-icon-wrap">
                                            <img [src]="commonImagePath+'download_img.webp'" class="down-color" alt="Download Icon"
                                                loading="lazy">
                                        </span>
                                        <a class="instruction-link cursor-pointer"
                                            [href]="cdnImagePath+instruction.instruction_file" download=""
                                            target="_blank" rel="noopener">
                                            Download Instructions
                                        </a>
                                    </td>
                                    <td class="doc-action" *ngIf="isVideoAvailable">
                                        <a class="instruction-link cursor-pointer"
                                            data-toggle="modal" data-target="#myModal-video">
                                            View Video
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>